import React, { Component } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import sweetAlert, {
sweetStatusAlert,
sweetConfirmAlert
} from "../../../../components/common/SweetAlert.js";
import { FormListService } from "../../../../service/manage/h_tree/form_list.service.js";
import { tableLogService } from "../../../../service/manage/h_tree/table_log.service.js";
import { formTypeService } from "../../../../service/manage/h_tree/form_type.service.js";
import Spinner from "react-bootstrap/Spinner";
import "../../../../components/admin/css/common.css";
import {
Table,
TableHead,
TableRow,
TableBody,
TableCell
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import SimpleReactValidator from "simple-react-validator";
import PageSpinner from "../../../../components/common/spinner/PageSpinner.js";
import ContentWrapper from "../../../../components/common/ContentWrapper.js";
import config from '../../../../helper/config.js';
import {customerConstants} from "../../../../helper/constants.js";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const getCustomerFeatureFlag = () => {
return config.customerConfigs.featureFlag;
};

let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
case customerConstants.EXO_CUSTOMER1:
    break;
case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
    color: "var(--maincolor-cmc)",
    backgroundColor: "#E5F5FF",
    borderColor: "transparent",
    };
    addBtnStyle = {
    color: "#fff",
    backgroundColor: "var(--maincolor-cmc)",
    borderColor: "transparent",
    };
    break;
default:
    break;
}

export default class ManageFormList extends Component {
constructor(props) {
    super(props);
    this.createValidationsInstance();
    this.state = {
        showModal: false,
        formLists: [],
        formTypes: [],
        tableLogs: [],
        title: "",
        main_table_id: "",
        status_id: "",
        form_list_id: "",
        form_code: "",
        form_list_id: "",
        modalType: false,
        search_val: "",
        isLoading: true,
        isSpinnerLoading: false,
        isModified: false,
        limit: 10, // Set the desired limit
        offset: 0, // Set the desired offset
        search_term: "",
        sort_column: "form_list_id",
        sort_direction: "ASC",
        totalFormLists: 10,
        currentPage: 0,
        editVisibility: true,
        addVisibility: true,
        deleteVisibility: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);

    // Debounced version of handleSearch function
    this.debouncedHandleSearch = debounce(this.fetchAllFormListData, 2000);
}

resetFormFields = () => {
    this.setState({
        title: "",
        main_table_id: "",
        status_id: "",
        form_list_id: "",
        form_code: "",
        form_list_id: "",
    });
};

componentDidMount() {
    this.getAllFormTypes();
    this.getAllTableLogs();
    this.fetchAllFormListData();
}

createValidationsInstance() {
    this.validator = new SimpleReactValidator();
}

getAllFormTypes = async() => {
    this.setState({ isLoading: true });
    await formTypeService.getAllFormTypes()
    .then((response) => {
        if (response.success) {
        this.setState({
            formTypes: response.data.form_types
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Form Types. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching Form Types. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
}

getFormTypeName(form_type_id) {
    if (form_type_id !== null) {
        const form_type = this.state.formTypes?.find(
            (form_type) => form_type.form_type_id == parseInt(form_type_id)
        );
        return form_type?.name;
    }
    else {
        return "N/A";
    }
}

getAllTableLogs = async() => {
    this.setState({ isLoading: true });
    await tableLogService.getAllTableLogs()
    .then((response) => {
        if (response.success) {
        this.setState({
            tableLogs: response.data.table_logs
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching Table Logs. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching Table Logs. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false });
    });
}

getTableName(table_id) {
    if (table_id !== null) {
        const table = this.state.tableLogs?.find(
            (table) => table.table_id == parseInt(table_id)
        );
        return table?.table_name;
    }
    else {
        return "N/A";
    }
}

getColor(state) {
    switch (state) {
      case "Disabled":
        return "label label-lg label-light-danger label-inline";
      case "Enabled":
        return "label label-lg label-success label-inline";
      default:
        return "label label-lg label-light-info label-inline";
    }
}

fetchAllFormListData() {
    const { limit, offset, search_term, sort_column, sort_direction } = this.state;
    FormListService.getAllForms(limit, offset, search_term, sort_column, sort_direction)
    .then((response) => {
        if (response.success) {
        this.setState({
            formLists: response.data.form_lists,
            totalFormLists: parseInt(response.data.total_count),
        });
        } else {
        sweetStatusAlert(
            "Failed!",
            "Error fetching form lists. Please refresh the screen!",
            "error"
        );
        }
    })
    .catch((error) => {
        sweetStatusAlert(
        "Failed!",
        "Error fetching form lists. Please refresh the screen!",
        "error"
        );
    })
    .finally(() => {
        this.setState({ isLoading: false, isSpinnerLoading: false });
    });
}

handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllFormListData();
    }
    );
};

handleSortChange = (sort_column) => {
    // If the same column is clicked, toggle the sort direction
    const { sort_column: currentSortColumn, sort_direction } = this.state;
    const newSortDirection =
        currentSortColumn === sort_column && sort_direction === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
        {
            sort_column,
            sort_direction: newSortDirection,
            offset: 0, // Reset offset when changing sorting
            currentPage: 0,
            isLoading: true,
        },
        () => {
            this.fetchAllFormListData();
        }
    );
};

handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
    {
        offset: newOffset,
        isLoading: true,
        currentPage: newPage
    },
    () => {
        this.fetchAllFormListData();
    }
    );
};

handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
    {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
    },
    () => {
        this.fetchAllFormListData();
    }
    );
};

handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
    this.setState(
        {
        search_term,
        isLoading: true,
        offset: 0,
        currentPage: 0,
        searchError: false,
        },
        () => {
            this.debouncedHandleSearch();
        }
    );
    } else {
        this.setState({ search_term, searchError: true });
    }
};

toggleFormListModal = (modalType) => {
    this.modalType = modalType;
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
    }));
};

toggleUpdateFormListModal = (title, form_list_id, main_table_id, status_id, form_code, form_type_id, modalType) => {
    this.setState((prevState) => ({
        showModal: !prevState.showModal,
        title: title,
        form_list_id: form_list_id,
        main_table_id: main_table_id,
        status: status_id,
        form_code: form_code,
        form_type_id: form_type_id,
        modalType: modalType,
    }));
};

handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
};

handleChangeFormType = (event) => {
    event.preventDefault();
    this.setState({ form_type_id: event.target.value });
};

handleChangeTable = (event) => {
    event.preventDefault();
    this.setState({ main_table_id: event.target.value });
};

handleSweetAlert = (modalType, modalVisibility) => {
    if (this.state.isModified) {
        sweetAlert().then((response) => {
            this.validator.hideMessages();
            this.validator.purgeFields();
            this.resetFormFields();
            this.modalType = false;
            this.setState(() => ({
            [modalVisibility]: response,
            isModified: false,
            }));
        });
    } else {
        this.validator.hideMessages();
        this.validator.purgeFields();
        this.resetFormFields();
        if (modalType) this.toggleFormListModal(false);
        else this.toggleUpdateFormListModal();
    }
};

//Handle Edit Submit
handleEditSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const formListItem = {
            title: this.state.title,
            form_code: this.state.form_code,
            main_table_id: this.state.main_table_id,
            status_id: this.state.status,
            form_type_id: this.state.form_type_id
        };
        const formListId = this.state.form_list_id;

        FormListService.updateFormList(formListItem, formListId)
            .then((response) => {
            if (response.success) {
                this.setState({ isSpinnerLoading: false });
                this.toggleFormListModal();
                sweetStatusAlert(
                "Success!",
                "Form type information updated successfully!",
                "success"
                );
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.fetchAllFormListData();
            }else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert(
                "Failed!",
                "Unable to update the form list information",
                "error"
            );
            });
    }
};

//add new Form List
handleSubmit = (event) => {
    event.preventDefault();

    if (!this.validator.allValid()) {
        this.validator.showMessages();
        this.forceUpdate();
    } 
    else 
    {
        this.setState({ isSpinnerLoading: true });
        const { title, form_code, main_table_id, status, form_type_id } = this.state;
        const newFormListItem = { title: title, form_code: form_code, main_table_id: main_table_id, status_id: status, form_type_id: form_type_id };

        FormListService.addFormList(newFormListItem)
            .then((response) => {
            if (response.success) {
                sweetStatusAlert("Success!", response.message.success, "success");
                this.validator.hideMessages();
                this.validator.purgeFields();
                this.resetFormFields();
                this.toggleFormListModal(false);
                this.fetchAllFormListData();
            } else {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", response.message, "error");
            }
            })
            .catch((err) => {
                this.setState({ isSpinnerLoading: false });
                sweetStatusAlert("Failed!", "Unable to create new form list", "error");
            });
    }
};

handleDeleteFormList = (id) => {
    sweetConfirmAlert().then(() => {
    this.setState({ isSpinnerLoading: true });
    FormListService.deleteFormList(id)
        .then((response) => {
        this.setState({ isSpinnerLoading: false });
        if (response.success) {
            sweetStatusAlert("Success!", response.message.success, "success");
            this.fetchAllFormListData();
        } else {
            sweetStatusAlert("Failed!", response.message, "error");
        }
        })
        .catch((error) => {
            this.setState({ isSpinnerLoading: false });
            sweetStatusAlert("Oops!", "Error while deleting the form list", "info");
        });
    });
};

render() {
    const {
        limit,
        formLists,
        totalFormLists,
        isLoading,
        currentPage,
        isSpinnerLoading,
        editVisibility,
        addVisibility,
        deleteVisibility,
    } = this.state;
    return (
    <>
        <ContentWrapper>
        <div className="row justify-content-between align-items-center py-5 mb-3">
            <div className="col-md-6 col-6">
            <h3 className="text-nowrap">Manage Form Lists</h3>
            </div>
            <div>
            {addVisibility && (
                <Button
                    className="insert-btn"
                    variant="primary"
                    onClick={() => this.toggleFormListModal(true)}
                >
                    Add Form List
                </Button>
            )}
            </div>
        </div>
        <div>
            <Form.Group controlId="exampleForm.ControlInput1" className="mb-2">
            <Form.Control
                type="text"
                placeholder="Search"
                onChange={this.handleSearch}
                isInvalid={this.state.searchError}
                // style={{ width: "18%" }}
                className="col-md-3 col-12"
            />
            {this.state.searchError && (
                <Form.Control.Feedback type="invalid">
                    Invalid input
                </Form.Control.Feedback>
            )}
            </Form.Group>
            {isSpinnerLoading && (
            <PageSpinner id="show" text="Loading, Please wait!" />
            )}
            {isLoading ? (
            <div
                className="loading-container"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "75vw",
                    height: "90vh",
                }}
            >
                <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
                </Spinner>
            </div>
            ) : formLists.length > 0 ? (
            <div style={{ width: "75vw", height: "90vh", overflow: "auto" }}>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("form_list_id")}
                    >
                        Form List ID{" "}
                        {this.state.sort_column === "form_list_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("form_code")}
                    >
                        Form Code{" "}
                        {this.state.sort_column === "form_code" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("name")}
                    >
                        Form Type{" "}
                        {this.state.sort_column === "name" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("title")}
                    >
                        Title{" "}
                        {this.state.sort_column === "title" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("main_table_id")}
                    >
                        Main Table ID{" "}
                        {this.state.sort_column === "main_table_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    <TableCell
                        className="thead"
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleSortChange("status_id")}
                    >
                        Status{" "}
                        {this.state.sort_column === "status_id" && (
                        <span>{this.state.sort_direction === "ASC" ? <ArrowDownwardIcon sx={{ fontSize: 15 }} /> : <ArrowUpwardIcon sx={{ fontSize: 15 }} />}</span>
                        )}
                    </TableCell>
                    {(editVisibility || deleteVisibility) && (
                        <TableCell className="thead">Actions</TableCell>
                    )}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {formLists.map((formListItem) => (
                    <TableRow key={formListItem.form_list_id}>
                        <TableCell className="tData">
                            {formListItem.form_list_id}
                        </TableCell>
                        <TableCell className="tData">
                            {formListItem.form_code}
                        </TableCell>
                        <TableCell className="tData">
                            {formListItem.form_type_id !== null ? formListItem.name : 'N/A'}
                        </TableCell>
                        <TableCell className="tData">
                            {formListItem.title}
                        </TableCell>
                        <TableCell className="tData">
                            {formListItem.main_table_id !== null ? this.getTableName(formListItem.main_table_id) : 'N/A'}
                        </TableCell>
                        <TableCell className="tData">
                            <div className={this.getColor(formListItem.status_id === 1 ? "Enabled" : "Disabled")}>
                                {formListItem.status_id === 1 ? "Enabled" : "Disabled"}
                            </div>
                        </TableCell>
                        {(editVisibility || deleteVisibility) && (
                        <TableCell>
                            <div className="btn-group">
                            {editVisibility && (
                                <Button
                                    onClick={() =>
                                        this.toggleUpdateFormListModal(
                                            formListItem.title,
                                            formListItem.form_list_id,
                                            formListItem.main_table_id,
                                            formListItem.status_id,
                                            formListItem.form_code,
                                            formListItem.form_type_id,
                                            false
                                        )
                                    }
                                    className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn flaticon-edit-icon"
                                    title="Edit Details"
                                />
                            )}
                            {deleteVisibility && (
                                <Button
                                    onClick={() =>
                                        this.handleDeleteFormList(
                                            formListItem.form_list_id
                                        )
                                    }
                                    className="btn btn-icon btn-danger btn-sm m-1 delete-assement-btn flaticon-delete"
                                    title="Delete"
                                />
                            )}
                            </div>
                        </TableCell>
                        )}
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
                <MaterialCustomTablePagination
                    totalCount = {totalFormLists}
                    currentPage = {currentPage}
                    limit = {limit}
                    handlePageChange = {this.handlePageChange}
                    handleRowsPerPageChange = {this.handleRowsPerPageChange}
                    handlePageOffsetChange = {this.handlePageOffsetChange}
                    offset = {this.state.offset}
                    rowsPerPageOptions={[5, 10, 20]}
                />
            </div>
            ) : (
            <div
                className="text-center mb-5 mt-10"
                style={{ height: "90vh" }}
            >
                <label>No Form Lists Available!</label>
            </div>
            )}
        </div>
        </ContentWrapper>

        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showModal}
            onHide={() => this.handleSweetAlert(this.modalType, "showModal")}
        >
        {this.modalType === true ? (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Create New Form List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Form Code*</Form.Label>
                    <Form.Control
                        type="text"
                        name="form_code"
                        placeholder="Type form code here..."
                        value={this.state.form_code ? this.state.form_code : ""}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "form_code",
                        this.state.title,
                        "required|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The form code should not be greater than 60 characters.",
                            required: "The form code is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Form Title*</Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        placeholder="Type title here..."
                        value={this.state.title ? this.state.title : ""}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "title",
                        this.state.title,
                        "required|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The form title should not be greater than 60 characters.",
                            required: "The form title is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Form Type*</Form.Label>
                    <Form.Select
                            id="form_type"
                            value={this.state.form_type_id || ""}
                            onChange={this.handleChangeFormType}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.formTypes.map((option, index) => (
                                <option key={index} value={option.form_type_id}>
                                    {option.name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "form_type",
                        this.state.form_type_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Main Table*</Form.Label>
                    <Form.Select
                            id="main_table"
                            value={this.state.main_table_id || ""}
                            onChange={this.handleChangeTable}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "main_table",
                        this.state.main_table_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        id="status"
                        value={this.state.status ?? 0}   
                        onChange={(e) => this.setState({ status: parseInt(e.target.value) })}
                        className="form-control"
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            Nothing Selected
                        </option>
                        <option value="1">Enabled</option>
                        <option value="0">Disabled</option>
                    </Form.Select>
                    {this.validator.message(
                        "status",
                        this.state.status,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleSubmit}
                >
                    Save changes
                </Button>
                <Button
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        ) : (
            <div>
            <Modal.Header closeButton>
                <Modal.Title>Update Form List</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Form Code*</Form.Label>
                    <Form.Control
                        type="text"
                        name="form_code"
                        placeholder="Type form code here..."
                        value={this.state.form_code ? this.state.form_code : ""}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "form_code",
                        this.state.title,
                        "required|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The form code should not be greater than 60 characters.",
                            required: "The form code is required.",
                        },
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Form Title*</Form.Label>
                    <Form.Control
                        type="text"
                        name="title"
                        placeholder="Type title here..."
                        value={this.state.title ? this.state.title : ""}
                        onChange={this.handleChange}
                    />
                    {this.validator.message(
                        "title",
                        this.state.title,
                        "required|max:60",
                        {
                        className: "text-danger",
                        messages: {
                            max: "The form title should not be greater than 60 characters.",
                            required: "The form title is required.",
                        },
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row className="my-5">
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Form Type*</Form.Label>
                    <Form.Select
                            id="form_type"
                            value={this.state.form_type_id || ""}
                            onChange={this.handleChangeFormType}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.formTypes.map((option, index) => (
                                <option key={index} value={option.form_type_id}>
                                    {option.name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "form_type",
                        this.state.form_type_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                    <Form.Group
                        as={Col}
                        md="6"
                        controlId="exampleForm.ControlInput1"
                    >
                    <Form.Label>Select Main Table*</Form.Label>
                    <Form.Select
                            id="main_table"
                            value={this.state.main_table_id || ""}
                            onChange={this.handleChangeTable}
                            className="form-control"
                        >
                            <option value="" disabled hidden style={{ color: "#6c757d" }}>Nothing Selected</option>
                            {this.state.tableLogs.map((option, index) => (
                                <option key={index} value={option.table_id}>
                                    {option.table_name}
                                </option>
                            ))}
                    </Form.Select>
                    {this.validator.message(
                        "main_table",
                        this.state.main_table_id,
                        "required",
                        {
                        className: "text-danger",
                        }
                    )}
                    </Form.Group>
                </Row>
                <Row>
                    <Form.Group as={Col} md="6" controlId="exampleForm.ControlInput1">
                    <Form.Label>Status*</Form.Label>
                    <Form.Select
                        id="status"
                        value={this.state.status ?? 0}   
                        onChange={(e) => this.setState({ status: parseInt(e.target.value) })}
                        className="form-control"
                    >
                        <option value="" disabled hidden style={{ color: "#6c757d" }}>
                            Nothing Selected
                        </option>
                        <option value="1">Enabled</option>
                        <option value="0">Disabled</option>
                    </Form.Select>
                    {this.validator.message(
                        "status",
                        this.state.status,
                        "required",
                        { className: "text-danger" }
                    )}
                    </Form.Group>
                </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="modal-btn"
                    variant="primary"
                    style={addBtnStyle}
                    onClick={this.handleEditSubmit}
                >
                    Save changes
                </Button>
                <Button
                    className="modal-btn"
                    id="modal-close-button"
                    style={closeBtnStyle}
                    onClick={() =>
                        this.handleSweetAlert(this.modalType, "showModal")
                    }
                >
                    Close
                </Button>
            </Modal.Footer>
            </div>
        )}
        </Modal>
    </>
    );
}
}
